import { customerApiClient } from 'api'

export const resendInvite = (token, orgId, email) => {
    return customerApiClient.post(`/organizations/${orgId}/users/reinvite/relay?relayToken=${token}`, { email })
}

export const copyReinviteLink = (token, orgId, email) => {
    return customerApiClient.post(`/organizations/${orgId}/users/reinvite_link/relay?relayToken=${token}`, { email })
}
